export default __webpack_public_path__ + "static/media/FB.8a8a0635.png";